'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-13d783d6.js');
var React = require('react');

var Neu = function (_a) {
    var className = _a.className, restProps = tslib_es6.__rest(_a, ["className"]);
    return (React.createElement("div", { className: className },
        React.createElement("svg", tslib_es6.__assign({ width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, restProps),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.75 19.5h-1.5v1.969L24 28.5V51h24V28.5l-11.25-7.031V19.5Zm-1.5 3.74-9.75 6.091V49.5h21V29.331l-9.75-6.09v2.354A3.001 3.001 0 0 1 36 31.5a3 3 0 0 1-.75-5.905V23.24Zm0 3.96a1.5 1.5 0 1 0 1.5 0v1.3h-1.5v-1.3Z", fill: "#323232" }))));
};

exports.default = Neu;
//# sourceMappingURL=index.js.map
